(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pp-reels"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pp-reels')) {
  customElements.define('pp-reels', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.track = this.querySelector('.pr-track');
      this.cards = [...this.querySelectorAll('.pr-card')];
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = new Set();
      this.visibleCards = new Set();
      if (!this.track || !this.cards.length) return;
      this.querySelectorAll('button').forEach(b => { b.hidden = false; });
      this.querySelectorAll('.pr-card video').forEach(v => { v.controls = false; v.muted = true; });
      this.addEventListener('click', event => {
        const button = event.target.closest('button[data-action]');
        if (!button) return;
        const card = button.closest('.pr-card');
        const video = card?.querySelector('video');
        const action = button.dataset.action;
        if (action === 'sound' && video) {
          const unmute = video.muted;
          this.querySelectorAll('video').forEach(v => { v.muted = true; });
          video.muted = !unmute;
          if (unmute) { this.userPaused.delete(video); this.play(video); }
          this.updateSound();
        }
      },{signal});
      this.cards.forEach(card => {
        const video = card.querySelector('video');
        video.addEventListener('play',() => this.updatePlay(card),{signal});
        video.addEventListener('pause',() => this.updatePlay(card),{signal});
        video.addEventListener('error',() => { card.querySelector('.pr-error').hidden = false; },{signal});
      });
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && entry.intersectionRatio >= .6) this.visibleCards.add(entry.target);
          else this.visibleCards.delete(entry.target);
        });
        this.sync();
      },{threshold:[0,.6,1]});
      this.cards.forEach(card => this.observer.observe(card));
      document.addEventListener('visibilitychange',() => this.sync(),{signal});
      this.motion.addEventListener('change',() => this.sync(),{signal});
      this.addEventListener('shopify:block:select',e => {
        const card = this.cards.find(c => c.dataset.blockId === e.detail?.blockId);
        card?.scrollIntoView({block:'nearest',inline:'start',behavior:'instant'});
      },{signal});
    }
    play(video) {
      const pending = video.play();
      pending?.catch(() => { const card=video.closest('.pr-card'); if(card) this.updatePlay(card); });
    }
    sync() {
      this.cards.forEach(card => {
        const video=card.querySelector('video');
        if (document.hidden || !this.visibleCards.has(card)) video.pause();
        else if (this.dataset.autoplay === 'true' && !this.motion.matches && !this.userPaused.has(video)) this.play(video);
      });
    }
    updatePlay(card) {
      const video=card.querySelector('video');
      const button=card.querySelector('[data-action="toggle"]');
      if (!button) return;
      button.setAttribute('aria-label', video.paused ? this.dataset.play : this.dataset.pause);
      button.querySelector('[data-icon="play"]').toggleAttribute('hidden',!video.paused);
      button.querySelector('[data-icon="pause"]').toggleAttribute('hidden',video.paused);
    }
    updateSound() {
      this.cards.forEach(card => {
        const muted=card.querySelector('video').muted;
        const button=card.querySelector('[data-action="sound"]');
        button.setAttribute('aria-label',muted?this.dataset.unmute:this.dataset.mute);
        button.setAttribute('aria-pressed',String(!muted));
        button.querySelector('[data-icon="muted"]').toggleAttribute('hidden',!muted);
        button.querySelector('[data-icon="sound"]').toggleAttribute('hidden',muted);
      });
    }
    disconnectedCallback() {
      this.querySelectorAll('video').forEach(v=>v.pause());
      this.controller?.abort(); this.observer?.disconnect();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pp-shipping-badge"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pp-shipping-label')) {
  customElements.define('pp-shipping-label', class extends HTMLElement {
    connectedCallback() {
      this.row = this.hasAttribute('data-fit-card') && this.closest('.pp-badge-row');
      if (!this.row) return;
      this.schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.fit());
      };
      this.observer = new ResizeObserver(([entry]) => {
        if (entry.contentRect.width === this.lastWidth) return;
        this.lastWidth = entry.contentRect.width;
        this.schedule();
      });
      this.observer.observe(this.row);
      window.addEventListener('resize', this.schedule);
      document.fonts.addEventListener('loadingdone', this.schedule);
      document.fonts.ready.then(() => this.isConnected && this.schedule());
      this.schedule();
    }

    fit() {
      if (!this.isConnected || !this.row.clientWidth) return;
      for (const property of ['font-size', 'line-height', 'padding-left', 'padding-right', 'max-width', 'white-space', 'overflow-wrap']) {
        this.style.removeProperty(property);
      }
      const style = getComputedStyle(this);
      const baseFont = parseFloat(style.fontSize);
      const baseLine = style.lineHeight;
      const ratio = parseFloat(baseLine) / baseFont || 1;
      const borders = parseFloat(style.borderLeftWidth) + parseFloat(style.borderRightWidth);
      const others = [...this.row.children].filter(element => element !== this);
      const gap = parseFloat(getComputedStyle(this.row).columnGap) || 0;
      const available = this.row.clientWidth - others.reduce((sum, element) => sum + element.getBoundingClientRect().width, 0) - gap * others.length;
      if (available <= 0) return;
      const range = document.createRange();
      range.selectNodeContents(this);
      const textWidth = () => range.getBoundingClientRect().width;
      const originalPadding = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
      if (textWidth() + originalPadding + borders <= available) return;
      const left = Math.min(3, parseFloat(style.paddingLeft));
      const right = Math.min(3, parseFloat(style.paddingRight));
      this.style.paddingLeft = `${left}px`;
      this.style.paddingRight = `${right}px`;
      this.style.maxWidth = `${available}px`;
      const innerWidth = Math.max(1, available - left - right - borders - 1);
      if (textWidth() <= innerWidth) return;
      let low = Math.min(8, baseFont);
      let high = baseFont;
      this.style.fontSize = `${low}px`;
      if (textWidth() > innerWidth) {
        this.style.whiteSpace = 'normal';
        this.style.overflowWrap = 'anywhere';
        this.style.lineHeight = String(ratio);
        return;
      }
      for (let step = 0; step < 7; step++) {
        const middle = (low + high) / 2;
        this.style.fontSize = `${middle}px`;
        if (textWidth() <= innerWidth) low = middle;
        else high = middle;
      }
      this.style.fontSize = `${low}px`;
      this.style.lineHeight = baseLine;
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      if (!this.schedule) return;
      window.removeEventListener('resize', this.schedule);
      document.fonts.removeEventListener('loadingdone', this.schedule);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pp-shipping-media-badge"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pp-shipping-media-badge')) {
    customElements.define('pp-shipping-media-badge', class extends HTMLElement {
      connectedCallback() {
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (String(data.sectionId) !== this.dataset.section) return;
          this.hidden = !data.variant?.available;
        });
      }
      disconnectedCallback() {
        this.unsubscribe?.();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
